import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BodyCopy } from '@xingternal/typography';

import { JobApplicationFormExternalDoc } from '@/graphql/generated';

import { ExternalDocumentList } from './external-document-list';
import { useExternalDocuments } from './use-external-documents';

type Props = { externalDocuments: JobApplicationFormExternalDoc[] };

export const ExternalDocuments: React.FC<Props> = ({ externalDocuments }) => {
  const { PRIVACY_POLICY, TERMS_AND_CONDITIONS, OTHER } = useExternalDocuments(externalDocuments);

  return (
    <BodyCopy>
      <FormattedMessage id="JOBS_POSTING_XING_APPLY_PRIVACY_POLICY_LINKS" />
      {TERMS_AND_CONDITIONS ? (
        <ExternalDocumentList
          urlsOfExternalDocumentsType={TERMS_AND_CONDITIONS}
          copyId="JOBS_INSTANT_APPLY_TERMS_LINK_TEXT_WEB"
        />
      ) : null}
      {PRIVACY_POLICY ? (
        <ExternalDocumentList
          urlsOfExternalDocumentsType={PRIVACY_POLICY}
          copyId="JOBS_INSTANT_APPLY_PRIVACY_LINK_TEXT"
        />
      ) : null}
      {OTHER ? (
        <ExternalDocumentList urlsOfExternalDocumentsType={OTHER} copyId="JOBS_INSTANT_APPLY_DOCUMENT_LINK_TEXT" />
      ) : null}
    </BodyCopy>
  );
};
